module.exports = __webpack_public_path__ + "media/images/application/template/logos/nottstrent-753c1d4c1e37ac6d2ad039a3f16399ff.png";